<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 13:51:29
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-31 14:46:33
 -->
<template>
  <div class="navMenu">
    <span :class="[`tabItem ${active === index ? 'active' : ''}`]" v-for="(item, index) in productNavMenuConfigData" :key="index" @click="goPath(item.path, index)">{{item.name}}</span>
  </div>
</template>

<script>
export default {
  name: 'navMenu',
  components: {
  },
  data () {
    return {
      active: 0,
      productNavMenuConfigData: [
        {
          name: '总览',
          path: 'productMonitorOverview',
        },
        {
          name: '路产管理平台',
          path: 'roadPropertyMana',
        },
        {
          name: '机电运维平台',
          path: 'electromechanicalMaintenance',
        },
        {
          name: '智慧服务区',
          path: 'serviceArea',
        },
        {
          name: '路网态势感知平台',
          path: 'roadNetworkSituationAwareness',
        },
        {
          name: '车型识别一体机',
          path: 'vehicleIdentification',
        },
        {
          name: '护栏碰撞预警系统',
          path: 'guardrailCollision',
        },        
        {
          name: '非现场执法运维平台',
          path: 'HardwareOperation',
        },
      ],
    }
  },
  methods: {
    /**
     * @description                   路由跳转
     * @param  {String}               路由name
     * @return {undefied}             无返回值
     */
    goPath (path, index) {
      this.$router.push({
        name: path,
      })
      this.active = index
    },
    /**
     * @description                   页面刷新时设置选中状态
     * @return {undefied}             无返回值
     */
    setRefreshSelectedStatus () {
      const matched = this.$route.matched[2].path.split('/')
      switch (matched[2]) {
        case 'productMonitorOverview':
          this.active = 0
          break
        case 'roadPropertyMana':
          this.active = 1
          break
        case 'electromechanicalMaintenance':
          this.active = 2
          break
        case 'serviceArea':
          this.active = 3
          break
        case 'roadNetworkSituationAwareness':
          this.active = 4
          break
        case 'vehicleIdentification':
          this.active = 5
          break
        case 'guardrailCollision':
          this.active = 6
          break      
        case 'HardwareOperation':
          this.active = 7
          break
      }
    },
  },
  created () {
    this.setRefreshSelectedStatus()
  },
}
</script>

<style lang="less" scoped>
  .navMenu {
    width: 68%;
    height: 13%;
    position: absolute;
    bottom: 3%;
    left: 17.5%;
    display: flex;
    justify-content: space-around;
    z-index: 10000;
    .tabItem {
      display: inline-block;
      white-space: nowrap;
      width: 13%;
      height: 75%;
      text-align: center;
      background: url('/static/img/layout/tab.png');
      background-size: 100% 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 1.9vh;
      font-weight: bold;
      cursor: pointer;
      font-family: 'YouSheBiaoTiHei';
      transition: transform 0.4s;
      &:hover {
        transform: scale(1.2);
      }
    }
    .active {
      background: url('/static/img/layout/tab-selected.png');
      background-size: 100% 100%;
      color: #00ffee;
      text-shadow: 3px 2px 2px #009c92;
    }
    >span:nth-of-type(1) {
      position: absolute;
      bottom: -10%;
      left: -8%;
    }
    >span:nth-of-type(2) {
      position: absolute;
      bottom: 0;
      left: 6%;
    }
    >span:nth-of-type(3) {
      position: absolute;
      bottom: 8%;
      left: 20%;
    }
    >span:nth-of-type(4) {
      position: absolute;
      bottom: 16%;
      left: 34%;
    }
    >span:nth-of-type(5) {
      position: absolute;
      top: 0;
      left: 48%;
    }
    >span:nth-of-type(6) {
      position: absolute;
      bottom: 16%;
      left: 62%;
    }
    >span:nth-of-type(7) {
      position: absolute;
      bottom: 8%;
      left: 76%;
    }
    >span:nth-of-type(8) {
      position: absolute;
      bottom: -10%;
      left: 90%;
    }
  }
</style>
